// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarMenuItem__container-e0b596 {
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 48px;
  padding: 0 16px;
  cursor: pointer;
  text-decoration: none;
}

.SidebarMenuItem__container-e0b596:hover,
.SidebarMenuItem__container-e0b596:focus {
  background-color: var(--base-15);
}

.SidebarMenuItem__active-a830b1,
.SidebarMenuItem__active-a830b1:hover,
.SidebarMenuItem__active-a830b1:focus,
.SidebarMenuItem__container-e0b596:active {
  background-color: var(--base-20);
}

.SidebarMenuItem__icon-a34707 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: var(--brand-primary-40);
}

.SidebarMenuItem__icon-a34707 > svg {
  fill: var(--addition-50);
}

.SidebarMenuItem__title-c38f12 {
  margin-inline-start: 16px;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SidebarMenuItem/SidebarMenuItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;AACF;;AAEA;;EAEE,gCAAA;AACF;;AAEA;;;;EAIE,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,yBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 48px;\n  padding: 0 16px;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.container:hover,\n.container:focus {\n  background-color: var(--base-15);\n}\n\n.active,\n.active:hover,\n.active:focus,\n.container:active {\n  background-color: var(--base-20);\n}\n\n.icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background-color: var(--brand-primary-40);\n}\n\n.icon > svg {\n  fill: var(--addition-50);\n}\n\n.title {\n  margin-inline-start: 16px;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SidebarMenuItem__container-e0b596`,
	"active": `SidebarMenuItem__active-a830b1`,
	"icon": `SidebarMenuItem__icon-a34707`,
	"title": `SidebarMenuItem__title-c38f12`
};
module.exports = ___CSS_LOADER_EXPORT___;
